import React from 'react'

const SkeletonLoader = () => {
  return (
    <div className="rounded-xl border border-gray-300 mt-6 sm:mt-8 overflow-hidden animate-pulse">
      {/* Phone View*/}
      <div className="flex flex-col md:hidden bg-white rounded-xl ">
        <div className="h-[150px] bg-gray-300 rounded-t-lg"></div>
        <div className="p-6 w-full flex flex-col gap-4 justify-start items-start">
          <div className="flex flex-col gap-2 w-full">
            <div className="h-4 bg-gray-300 rounded-md w-10/12"></div>
            <div className="h-8 bg-gray-300 rounded-md w-6/12"></div>
            <div className="h-4 bg-gray-300 rounded-md w-3/12"></div>
          </div>
          <div className="flex flex-col gap-2 w-full">
            <div className="flex space-x-1">
              <div className="h-5 bg-gray-300 rounded-md w-2/12"></div>
              <div className="h-5 bg-gray-300 rounded-md w-3/12"></div>
              <div className="h-5 bg-gray-300 rounded-md w-1/12"></div>
            </div>
          </div>
          <div className="flex flex-col gap-2 w-full">
            <div className="h-5 bg-gray-300 rounded-md w-full"></div>
            <div className="h-5 bg-gray-300 rounded-md w-10/12"></div>
            <div className="h-5 bg-gray-300 rounded-md w-11/12"></div>
          </div>
        </div>
      </div>
      {/* Tablet & Desktop View */}
      <div className="hidden md:flex bg-white rounded-xl ">
        <div className="w-[308px] bg-gray-300"></div>
        <div className="p-6 w-[calc(100%-320px)] flex flex-col gap-4 justify-start items-start">
          <div className="flex flex-col gap-2 w-full">
            <div className="h-4 bg-gray-300 rounded-md w-10/12"></div>
            <div className="h-8 bg-gray-300 rounded-md w-6/12"></div>
            <div className="h-4 bg-gray-300 rounded-md w-3/12"></div>
          </div>
          <div className="flex flex-col gap-2 w-full">
            <div className="flex space-x-1">
              <div className="h-4 bg-gray-300 rounded-md w-3/12"></div>
              <div className="h-4 bg-gray-300 rounded-md w-3/12"></div>
            </div>
            <div className="flex space-x-1">
              <div className="h-5 bg-gray-300 rounded-md w-2/12"></div>
              <div className="h-5 bg-gray-300 rounded-md w-3/12"></div>
              <div className="h-5 bg-gray-300 rounded-md w-1/12"></div>
              <div className="h-5 bg-gray-300 rounded-md w-3/12"></div>
            </div>
          </div>
          <div className="flex flex-col gap-2 w-full">
            <div className="h-5 bg-gray-300 rounded-md w-full"></div>
            <div className="h-5 bg-gray-300 rounded-md w-10/12"></div>
            <div className="h-5 bg-gray-300 rounded-md w-11/12"></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SkeletonLoader
